import React from 'react'
import { Link } from "react-router-dom";

const AiNav = () => {
    return (
        <nav>
            <ul className="nav flex-column">
                <li className="nav-item">
                    <Link to="/admin/ai/dashboard" className="nav-link">
                        Dashboard
        </Link>
                </li>
                <li className="nav-item">
                    <Link to="/admin/ai/price" className="nav-link">
                        Add Sale
        </Link>
                </li>
                <li className="nav-item">
                    <Link to="/admin/ai/products" className="nav-link">
                        Add Products
        </Link>
                </li>

                <li className="nav-item">
                    <Link to="/admin/dashboard" className="nav-link">
                        Back
        </Link>
                </li>
            </ul>
        </nav>
    )
}

export default AiNav
